import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { RowDataCancel } from 'src/reducers/liveorderfile';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';

interface TableState {
    columns: Array<Column<RowDataCancel>>;
    data: RowDataCancel[];
}

export interface CancelOrderPageViewProps {
    cancelOrderData: RowDataCancel[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    // submitRework: (column: Object) => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '10px'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        // iconPadding: {
        //     padding: '6px'
        // },
        iconClose: {
            position: 'absolute',
            right: 0
        },
        button: {
            margin: theme.spacing(1),
        },
        textArea: {
            display: 'flex',
            justifyContent: 'center',
            margin: '20px'
        }
    })
);

const CancelOrderPageView: React.StatelessComponent<CancelOrderPageViewProps> = (props) => {
    const classes = useStyles({});
    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                },
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         // padding: '5px 10px',
            //         fontSize: '13px'
            //     }
            // },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px'
                },
            },
            {
                title: 'Uploaded On',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px',
                    textAlign: 'center'
                },
            },
            {
                title: 'Remarks',
                field: 'cancelremarks',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px',
                    textAlign: 'center'
                },
            },
            {
                title: 'Cancelled On',
                field: 'cancelledon',
                filtering: false,
                cellStyle: {
                    // padding: '5px 10px',
                    fontSize: '13px',
                    textAlign: 'center'
                },
            }
        ],
        data: props.cancelOrderData
    });
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                            <AutorenewIcon />
                        </Fab>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Cancelled Order"
                        columns={state.columns}
                        data={props.cancelOrderData}
                        localization={{
                            toolbar: {
                                exportTitle: 'Export as Excel'
                            },
                            // header: {
                            //     actions: ''
                            // },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        options={{
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            sorting: true,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '10px',
                                textAlign: 'center'
                            },
                            exportButton: true,
                            exportAllData: true,
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default CancelOrderPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/CancelOrderPageView.tsx